// Gestion du menu hamburger pour les écrans mobiles
import { useState, useEffect } from 'react';

const MenuHamburger = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Ajouter un écouteur d'événement pour le clic sur le menu hamburger
    useEffect(() => {
        const mobileNav = document.querySelector('.mobile-nav');
        const menuHamburger = document.querySelector('.hamburger');

        if (!mobileNav || !menuHamburger) {
            return undefined;
        }

        const closeMenu = () => {
            mobileNav.classList.remove('active');
            menuHamburger.classList.remove('active');
            setIsMenuOpen(false);
        };

        const handleClickOutside = (event) => {
            if (!mobileNav.contains(event.target) && !menuHamburger.contains(event.target)) {
                closeMenu();
            }
        };

        mobileNav.addEventListener('click', closeMenu);
        document.addEventListener('click', handleClickOutside);

        return () => {
            mobileNav.removeEventListener('click', closeMenu);
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    // Ajouter un écouteur d'événement pour le clic sur les liens de navigation mobile

    const toggleMenu = () => {
        const mobileNav = document.querySelector('.mobile-nav');
        const menuHamburger = document.querySelector('.hamburger');
        const shouldOpen = !isMenuOpen;
        mobileNav.classList.toggle('active', shouldOpen);
        menuHamburger.classList.toggle('active', shouldOpen);
        setIsMenuOpen(shouldOpen);
    };



    return (
        <div className="hamburger" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
    );
};

export default MenuHamburger;